import React, {PropTypes, Component} from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'
import {Form, actions} from 'react-redux-form/immutable'
import {Fieldset, Row, Field} from 'react-gridforms'
import Trash from 'react-icons/lib/md/delete'

import Input from 'components/Input'
import InputSelectMultiple from 'components/InputSelectMultiple'
import InputCheckbox from 'components/InputCheckbox'

import {int, number, required} from 'utils/validators'

const validators = {
  year: {int},
  sem: {required},
  code: {required},
  name: {required},
  lec_units: {number},
  lab_units: {number},
  lec_hrs: {number},
  lab_hrs: {number},
  units: {number},
  funits: {number},
  punits: {number},
  hours: {number},
  lab_type: {required},
}

class FormCurriculumSubject extends Component {
  componentDidMount() {
    const {dispatch, item, __subjectState} = this.props

    // update
    if (item) {
      dispatch(actions.change('curriculumSubjectState', item))
    } else {
      // reset form
      dispatch(actions.change('curriculumSubjectState.id', 0))
      dispatch(actions.change('curriculumSubjectState.code', ''))
      dispatch(actions.change('curriculumSubjectState.name', ''))
      dispatch(actions.change('curriculumSubjectState.prereq', fromJS([])))
      dispatch(actions.change('curriculumSubjectState.coreq', fromJS([])))
      //dispatch(actions.reset('curriculumSubjectState'))
    }
  }

  render() {
    const {item, subjectOptions, pending, onSubmit, onDelete} = this.props

    const isEdit = !!item
    const submit = pending ? 'Saving...' : 'Save Curriculum Subject'
    const legend = isEdit ? 'Edit Curriculum Subject' : 'Add Curriculum Subject'

    return (
      <Form
        model="curriculumSubjectState"
        className="grid-form"
        validators={validators}
        onSubmit={onSubmit}
      >
        <Fieldset legend={legend}>
          <Row>
            <Field span="2">
              <Input model=".code" label="Subject Code" required autoFocus />
            </Field>
            <Field span="4">
              <Input model=".name" label="Subject Description" required />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input model=".lec_units" label="Lec Units" required />
            </Field>
            <Field>
              <Input model=".lab_units" label="Lab Units" required />
            </Field>
            <Field>
              <Input model=".units" label="Total Units" required />
            </Field>
            <Field>
              <Input model=".punits" label="Units to be Paid" required />
            </Field>
          </Row>
          <Row>
            <Field>
              <Input model=".lec_hrs" label="Lec Hours" required />
            </Field>
            <Field>
              <Input model=".lab_hrs" label="Lab Hours" required />
            </Field>
            <Field>
              <Input model=".hours" label="Total Hours Contact" required />
            </Field>
            <Field>
              <Input model=".funits" label="Faculty Units" required />
            </Field>
          </Row>
          <hr />
          <Row>
            <Field>
              <Input model=".year" label="Year" required />
            </Field>
            <Field>
              <Input model=".sem" label="Sem" required />
            </Field>
            <Field>
              <Input model=".lab_type" label="Lab Type" required />
            </Field>
            <Field>
              <InputCheckbox label="Active" model=".is_active" />
            </Field>
            <Field>
              <InputCheckbox label="Inc. GPA" model=".is_in_gpa" />
            </Field>
          </Row>
          <Row>
            <Field span="2">
              <InputSelectMultiple
                model=".prereq"
                label="PreRequisite(s)"
                options={subjectOptions}
              />
            </Field>
            <Field span="2">
              <InputSelectMultiple
                model=".coreq"
                label="CoRequisite(s)"
                options={subjectOptions}
              />
            </Field>
            <Field>
              <Input model=".standing" label="Standing:" />
            </Field>
          </Row>
        </Fieldset>
        <fieldset className="modal-footer" disabled={pending}>
          {isEdit &&
            <button onClick={onDelete} type="button" className="btn btn-icon">
              <Trash />
            </button>}
          <button type="submit" className="btn btn-success">{submit}</button>
        </fieldset>
      </Form>
    )
  }
}

FormCurriculumSubject.propTypes = {
  __subjectState: PropTypes.object,
  item: PropTypes.object,
  subjectOptions: PropTypes.array,
  pending: PropTypes.bool,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __subjectState: state.curriculumSubjectState,
  }
}

export default connect(mapStateToProps)(FormCurriculumSubject)



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/form-curriculum-subject.js